import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Flex, Text } from 'components/ui';
import {
    colors, fontSizes, fontWeights, mediaQueries
} from 'style/config';

function ProductInfo({ sku }) {
    return (
        <Flex
            flexDirection='column'
            gap='2px'
        >
            <Text
                css={styles.brandName}
                dangerouslySetInnerHTML={{ __html: sku.brandName }}
            />
            <Text
                css={styles.productName}
                dangerouslySetInnerHTML={{ __html: sku.productName }}
            />
            {sku.size && <Text css={styles.size}>{sku.size}</Text>}
            {sku.variationValue && (
                <Text css={styles.variation}>
                    {sku.variationTypeDisplayName || sku.variationType || 'Color'}:{' '}
                    {[sku.variationValue, sku.variationDesc && ` - ${sku.variationDesc}`]}
                </Text>
            )}
        </Flex>
    );
}

const styles = {
    brandName: {
        fontSize: `${fontSizes.base}px`,
        fontWeight: fontWeights.bold,
        lineHeight: '18px',
        [mediaQueries.xsMax]: {
            fontSize: `${fontSizes.sm}px`,
            lineHeight: 'normal'
        }
    },
    productName: {
        fontSize: `${fontSizes.base}px`,
        lineHeight: '18px',
        [mediaQueries.xsMax]: {
            fontSize: `${fontSizes.sm}px`,
            lineHeight: '14px'
        }
    },
    size: {
        fontSize: `${fontSizes.sm}px`,
        lineHeight: '14px',
        color: colors.gray,
        [mediaQueries.xsMax]: {
            fontSize: `${fontSizes.xs}px`
        }
    },
    variation: {
        fontSize: `${fontSizes.sm}px`,
        lineHeight: '14px',
        color: colors.black,
        [mediaQueries.xsMax]: {
            fontSize: `${fontSizes.xs}px`
        }
    }
};

ProductInfo.propTypes = {
    sku: PropTypes.shape({
        brandName: PropTypes.string,
        productName: PropTypes.string,
        size: PropTypes.string,
        variationType: PropTypes.string,
        variationTypeDisplayName: PropTypes.string,
        variationValue: PropTypes.string,
        variationDesc: PropTypes.string
    }).isRequired
};

export default wrapFunctionalComponent(ProductInfo, 'ProductInfo');
